<template>
  <vx-card :title="title">
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="my-2" type="border" color="danger" v-on:click="handleClose">
          Back
        </vs-button>
      </div>
    </div>
    <!-- Ngetes tabs -->
    <div class="vx-row mt-3">
      <vs-tabs v-if="rendered" ref="tabs">
        <vs-tab v-for="(dt, i) in dataCustomerOrder" :key="i" :label="''+(dt.code)" @click="redirectTab(i)">
          <!-- Start -->
          <!-- Pembagian dan pengelompokan dropdown -->
          <!-- 1st row : Customer Data & Segmentation Data -->
          <div class="vx-row mt-3">
            <!-- Customer Data -->
            <div class="vx-col sm:w-1/2 w-full mb-base">
              <span class="py-2 h5 font-semibold">Customer Data</span><hr>
              <!-- One time cust -->
              <div class="vx-row my-6">
                <div class="vx-col sm:w-1/3">
                  One Time
                </div>
                <div class="vx-col sm:w-2/6">
                  <vs-switch
                    color="dark"
                    icon-pack="feather"
                    vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash"
                    v-model="dt.is_onetime"
                    :disabled="true"
                  >
                    <span slot="on">YES</span>
                    <span slot="off">NO</span>
                  </vs-switch>
                </div>
              </div>
              <!-- Ship To -->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Shipp To</span>
                </div>
                <div v-if="!dt.is_onetime" class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    class="w-full"
                    type="text"
                    readonly
                    :value="dt.ship_to_code + ' - ' + dt.ship_to_name"
                  />
                </div>
                <!-- Address Ship To -->
                <div class="vx-col sm:w-1/3 w-full">
                  <span></span>
                </div>
                <div v-if="!dt.is_onetime" class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    class="w-full"
                    type="text"
                    readonly
                    :value="dt.ship_to_address"
                  />
                </div>
                <div v-else class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.onetime_cust_data.shipto_address" disabled/>
                </div>
              </div>

              <!-- Bill To -->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Bill to</span>
                </div>
                <div v-if="!dt.is_onetime" class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    class="w-full"
                    type="text"
                    readonly
                    :value="dt.bill_to_code + ' - ' + dt.bill_to_name"
                  />
                </div>
                <div v-else class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.onetime_cust_data.billto_address" disabled/>
                </div>
              </div>

              <!-- Customer -->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Customer</span>
                </div>
                <div v-if="!dt.is_onetime" class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    class="w-full"
                    type="text"
                    readonly
                    :value="dt.customer_code + ' - ' + dt.customer_name"
                  />
                </div>
                <div v-else class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="'['+dt.customer_code + ' - ' + dt.customer_name+'] ' + dt.onetime_cust_data.name" readonly/>
                </div>
              </div>

              <!-- Customer Name-->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Customer Name</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.customer_name" readonly/>
                </div>
              </div>

              <!-- Create By-->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Create By</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.created_by_name" readonly/>
                </div>
              </div>

              <!-- Creation Date-->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Creation Date</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="formatDate(dt.created_at)" readonly/>
                </div>
              </div>

              <!-- Customer Deposits --> 
              <div v-if="dt.category == 'ZDCBD'" class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Customer Deposits</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <multiselect
                    class="selectExample"
                    v-model="selectedCustDeposit"
                    :options="optionCustDeposit"
                    :multiple="true"
                    :allow-empty="false"
                    track-by="ID"
                    :max-height="200"
                    placeholder="Type to search"
                    :custom-label="customLableCustDeposit"
                    :disabled="true"
                  />
                </div>
              </div>

              <!-- Form onetime cust -->
              <div v-if="dt.is_onetime" class="w-full mt-6">
                  <span class="py-2 h5 font-semibold">One Time Customer Data</span><hr>

                  <!-- Customer Name-->
                  <div class="vx-row mb-6 mt-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Customer Name</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.name : ''" readonly/>
                    </div>
                  </div>

                  <!-- Country-->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Country</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.country : ''" readonly/>
                    </div>
                  </div>
                  
                  <!-- Province-->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Province</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.province : ''" readonly/>
                    </div>
                  </div>

                  <!-- City-->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>City</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.city : ''" readonly/>
                    </div>
                  </div>

                  <!-- District-->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>District</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.district : ''" readonly/>
                    </div>
                  </div>

                  <!-- Subdistrict -->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Subdistrict</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.sub_district : ''" readonly/>
                    </div>
                  </div>

                  <!-- Address -->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Address</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.billto_address : ''" readonly/>
                    </div>
                  </div>

                  <!-- Postal Code -->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Postal Code</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.postal_code : ''" readonly/>
                    </div>
                  </div>

                  <!-- Ship / Bill Address -->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Ship / Bill Address</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.billto_address : ''" readonly/>
                    </div>
                  </div>

                  <!-- Contact Person -->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Contact Person</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.contact_person : ''" readonly/>
                    </div>
                  </div>

                  <!-- NIK -->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>NIK</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.nik : ''" readonly/>
                    </div>
                  </div>

                  <!-- Phone Number -->
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <span>Phone Number</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" :value="dt.is_onetime ? dt.onetime_cust_data.phone : ''" readonly/>
                    </div>
                  </div>
              </div>
              <!-- End form otcust -->
            </div>
            <!-- </div> -->
            <!-- Segmentation Data -->
            <div class="vx-col sm:w-1/2 w-full mb-base">
              <span class="py-2 h5 font-semibold">Segmentation Data</span><hr>
              
              <!-- Territory -->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Territory</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.territory_code + ' - ' + dt.territory_name" readonly/>
                </div>
              </div>

              <!-- Zone -->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Zone</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.zone_code + ' - ' + dt.zone_name" readonly/>
                </div>
              </div>

              <!-- Sales Channel -->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Sales Channel</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.sales_channel_name" readonly/>
                </div>
              </div>

              <!-- Distribution Channel -->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Distribution Channel</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.distribution_channel" readonly/>
                </div>
              </div>

              <!-- Sales ID -->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Sales ID</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.personal_code_external + ' - ' + dt.personal_name" readonly/>
                </div>
              </div>

              <!-- Pricing Group -->
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Pricing Group</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.pricing_group_name + ' (' +dt.pricing_group_code+ ')'" readonly/>
                </div>
              </div>
            </div>
          </div>
          <!-- 2nd row : SO Data & Delivery Data -->
          <div class="vx-row">
            <!-- SO Data -->
            <div class="vx-col sm:w-1/2 w-full mb-base">
              <span class="pt-2 h5 font-semibold">SO Data</span><hr>

              <!-- SO Code-->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>SO Code</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input v-if="dt.customer_order_code != '' && dt.customer_order_code != null" class="w-full" :value="dt.customer_order_code + ` (Executed) `" readonly/>
                  <vs-input v-else class="w-full" :value="`(Yet Executed) `" readonly/>
                </div>
              </div>

              <!-- Ref. PO Code-->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Ref. PO Code</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.ex_code" readonly/>
                </div>
              </div>

              <!-- SO Type-->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>SO Type</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.coType.Code + ' - ' + dt.coType.Description" readonly/>
                </div>
              </div>

              <!-- Date-->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Date</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="formatDate(dt.date)" readonly/>
                </div>
              </div>

              <!-- PO Date-->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>PO Date</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="formatDate(dt.ex_date)" readonly/>
                </div>
              </div>

              <!-- Payment Term-->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Payment Term</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.top_name" readonly/>
                </div>
              </div>
            </div>

            <!-- Delivery Data -->
            <div class="vx-col sm:w-1/2 w-full mb-base">
              <span class="pt-2 h5 font-semibold">Delivery Data</span><hr>

              <!-- Allow Partial -->
              <div class="vx-row my-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Allow Partial</span>
                </div>
                <div class="vx-col vx-row sm:w-2/3 w-full">
                  <div class="vx-col sm:w-1/6">
                    <input type="radio" value="true" v-model="dt.allow_partial" :disabled="dt.allow_partial==true?!dt.allow_partial==true:true">
                    <label> Yes</label>
                  </div>
                  <div class="vx-col sm:w-1/6">
                    <input type="radio" value="false" v-model="dt.allow_partial" :disabled="dt.allow_partial==false?!dt.allow_partial==false:true">
                    <label> No</label>
                  </div>
                </div>
              </div>

              <!-- Delivery Type -->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Delivery Type </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.delivery_type" readonly/>
                </div>
              </div>

              <!-- Expense Type -->
              <div class="vx-row mb-6 mt-6" v-if="dt.coType.Code=='ZDSM'">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Expense Type </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="dt.expense_type" readonly/>
                </div>
              </div>

              <!-- Req. Delivery Date -->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Req. Delivery Date </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" :value="formatDate(dt.reques_delivery_date)" readonly/>
                </div>
              </div>

              <!-- Note -->
              <div class="vx-row mb-6 mt-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Note </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-textarea class="w-full" :value="dt.note" readonly height="110px"/>
                </div>
              </div>

              <!-- Flush Out -->
              <div class="vx-row my-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Flush Out</span>
                </div>
                <div class="vx-col vx-row sm:w-2/3 w-full">
                  <div class="vx-col sm:w-1/6">
                    <input type="radio" value="true" v-model="dt.is_flush_out" :disabled="dt.is_flush_out==true?!dt.is_flush_out==true:true">
                    <label> Yes</label>
                  </div>
                  <div class="vx-col sm:w-1/6">
                    <input type="radio" value="false" v-model="dt.is_flush_out" :disabled="dt.is_flush_out==false?!dt.is_flush_out==false:true">
                    <label> No</label>
                  </div>
                </div>
              </div>
              <!--  -->
            </div>
          </div>
          <!-- CO Line baru -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <table class="table table-bordered" style="width:100%">
                <thead>
                  <tr>
                    <th style="vertical-align: middle; text-align: center;"> SKU Code </th>
                    <th style="vertical-align: middle; text-align: center;"> Qty </th>
                    <th style="vertical-align: middle; text-align: center;"> HU </th>
                    <th style="vertical-align: middle; text-align: center;"> Cogs </th>
                    <th style="vertical-align: middle; text-align: center;"> Price </th>
                    <th style="vertical-align: middle; text-align: center;"> Subtotal </th>
                    <!-- Hide discount -->
                    <th style="vertical-align: middle; text-align: center;"> Discount </th>
                    <th style="vertical-align: middle; text-align: center;"> Rounding</th>
                    <th style="vertical-align: middle; text-align: center;"> Tax </th>
                    <th style="vertical-align: middle; text-align: center;"> Total </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Struktur baru, array-of-object -->
                  <template v-for="(dtl, index) in dt.customer_order_line">
                    <!-- <vs-tr :key="index" v-for="(dt, index) in 3"> -->
                    <tr :key="index" v-if="!dtl.is_combo" :class="'table-expend'">
                      <td v-on:click="expandNonCombo(i, index, dtl)" :rowspan="dtl.is_expand?2:null" v-if="(dtl.quantity > 0||dtl.is_combo) && parseFloat(dtl.price) > 0" style="vertical-align: middle;">
                        <strong>[{{dtl.sku_code}}] {{dtl.sku_name}} </strong>
                        <span v-if="dtl.item_type != undefined && dtl.item_type_name != undefined" class="badge badge-pill badge-success">{{ dtl.is_combo?"Combo Item":"Reguler" }}</span>
                      </td>
                      <td v-on:click="expandNonCombo(i, index, dtl)" :rowspan="dtl.is_expand?2:null" v-if="(dtl.quantity > 0 ||dtl.free_item) && parseFloat(dtl.price) > 0" style="text-align: right; vertical-align: middle;">{{dtl.quantity}}</td>
                      <td v-on:click="expandNonCombo(i, index, dtl)" :rowspan="dtl.is_expand?2:null" v-if="(dtl.quantity > 0 ||dtl.free_item) && parseFloat(dtl.price) > 0" style="vertical-align: middle;">{{dtl.unit}}</td>
                      <!-- format currency + toFixed2 -->
                      <!-- <td v-on:click="expandNonCombo(i, index, dtl)" style="text-align: right;">{{ dtl.cogs? formatCurrency(dtl.cogs.toFixed(2)):"" }}</td> --> 
                      <!--format currency only -->
                      <td v-on:click="expandNonCombo(i, index, dtl)" style="text-align: right;">{{ dtl.cogs? formatCurrency(dtl.cogs):"" }}</td> 
                      <!--raw-->
                      <!-- <td v-on:click="expandNonCombo(i, index, dtl)" style="text-align: right;">{{ dtl.cogs? dtl.cogs:"" }}</td>  -->
                      <td v-on:click="expandNonCombo(i, index, dtl)" v-if="(dtl.quantity > 0 ||dtl.free_item) && parseFloat(dtl.price) > 0" style="text-align: right;">@{{ !dtl.free_item?formatCurrency( parseFloat(dtl.price).toFixed(2) ):"" }}</td>
                      <td v-on:click="expandNonCombo(i, index, dtl)" v-if="(dtl.quantity > 0 ||dtl.free_item) && parseFloat(dtl.price) > 0" style="text-align: right;">{{ !dtl.free_item?formatCurrency( parseFloat(dtl.subtotal).toFixed(2) ):"" }}</td>
                      <!-- Hide discount -->
                      <td style="text-align: right;" v-on:click="detailDiscShow(i,index)"> 
                          <a href="javascript:void(0);"><b>{{formatCurrency(parseFloat(dtl.discount).toFixed(2))}} </b><i class="fa fa-eye"></i></a>
                      </td>
                      <td v-on:click="expandNonCombo(i, index, dtl)" v-if="(dtl.quantity > 0||dtl.free_item) && parseFloat(dtl.price) > 0" style="text-align: right;">{{ !dtl.free_item?parseFloat(dtl.Rounding).toFixed(2):"" }}</td>
                      <td v-on:click="expandNonCombo(i, index, dtl)" v-if="(dtl.quantity > 0||dtl.free_item) && parseFloat(dtl.price) > 0" style="text-align: right;">{{ !dtl.free_item?formatCurrency( parseFloat(dtl.Tax).toFixed(2) ):"" }}</td>
                      <td v-on:click="expandNonCombo(i, index, dtl)" v-if="(dtl.quantity > 0||dtl.free_item) && parseFloat(dtl.price) > 0" style="text-align: right;">{{ !dtl.free_item?formatCurrency( parseFloat( dtl.total).toFixed(2) ):"" }}</td>
                    </tr>

                    <tr :key="index+'combo'" v-if="dtl.is_combo">
                      <td :rowspan="dtl.detail_combo?getRowspanCombo(dtl.detail_combo):null">{{dtl.sku_code}}<br/>
                        <span v-if="dtl.free_item" class="badge badge-pill badge-success"
                          >Free</span >
                        <span v-else-if="dtl.is_combo" class="badge badge-pill badge-success"
                        >Combo</span>
                      </td>
                    </tr>

                    <tr :key="'expand-head-'+index+'-'+i" v-if="dtl.is_expand && dtl.detail_combo.length==0">
                      <td colspan="7" style="width:50%;">
                      <!-- expand-head -->
                        <tr>
                          <!-- <th>Width<br>
                            @{{ dtl.width }}
                          </th>
                          <th>
                            Height <br>
                            @{{ dtl.height }}
                          </th>
                          <th>Length<br>
                            @{{ dtl.length }}
                          </th> -->
                          <th>Weight<br>
                            @{{ dtl.weight }}
                          </th>
                          <th>Volume<br>
                            @{{ dtl.volume }}
                          </th>
                          <th>Net Weight<br>
                            @{{ dtl.net_weight }}
                          </th>
                          <th>Price Rule Code</th>
                          <th>Price Rule Valid From</th>
                          <th>Price Rule Valid To</th>
                          <th>Division Code</th>
                          <th>Division Description</th>
                        </tr>
                        <!-- expand-body -->
                        <tr>
                          <!-- <td>{{ dtl.total_width }}</td>
                          <td>{{ dtl.total_height }}</td>
                          <td>{{ dtl.total_length }}</td> -->
                          <td>{{ dtl.total_weight }}</td>
                          <td>{{ dtl.total_volume }}</td>
                          <td>{{ dtl.total_net_weight }}</td>
                          <td>{{ dtl.price_rule_code }}</td>
                          <td>{{ dtl.price_rule_valid_from }}</td>
                          <td>{{ dtl.price_rule_valid_to }}</td>
                          <td>{{ dtl.division_code }}</td>
                          <td>{{ dtl.division_description }}</td>
                        </tr>
                      </td>
                    </tr>

                    <template v-for="(dtl_c, i_c) in dtl.detail_combo">
                      <vs-tr :key="index+'combo-child'+i+''+i_c" :class="'table-expend'" v-on:click.native="expandCombo(i, index, i_c, dtl_c)">
                        <vs-td :rowspan="dtl_c.is_expand?2:null" v-if="(dtl_c.quantity > 0 ||dtl.free_item) && parseFloat(dtl_c.price) > 0">
                          <strong>{{dtl_c.sku_code}} - {{dtl_c.item_name}}</strong> <br>
                          <span v-if="dtl_c.item_type != undefined && dtl_c.item_type_name != undefined" class="text-success">{{dtl_c.item_type_name }}</span>
                        </vs-td>
                        <vs-td :rowspan="dtl_c.is_expand?2:null" v-if="(dtl_c.quantity > 0 ||dtl.free_item) && parseFloat(dtl_c.price) > 0" style="text-align: right;">{{dtl_c.quantity}}</vs-td>
                        <vs-td :rowspan="dtl_c.is_expand?2:null" v-if="(dtl_c.quantity > 0 ||dtl.free_item) && parseFloat(dtl_c.price) > 0">{{dtl_c.unit_name}}</vs-td>
                        <vs-td style="text-align: right;">{{ dtl_c.cogs?dtl_c.cogs:"" }}</vs-td>
                        <vs-td v-if="(dtl_c.quantity > 0 ||dtl.free_item) && parseFloat(dtl_c.price) > 0" style="text-align: right;">{{ !dtl.free_item?formatCurrency( parseFloat(dtl_c.price).toFixed(2) ):"" }}</vs-td>
                        <vs-td v-if="(dtl_c.quantity > 0 ||dtl.free_item) && parseFloat(dtl_c.price) > 0" style="text-align: right;">{{ !dtl.free_item?formatCurrency( parseFloat(dtl_c.subtotal).toFixed(2) ):"" }}</vs-td>
                        <!-- Hide discount -->
                        <vs-td style="text-align: right;"> {{ !dtl_c.free_item?formatCurrency( parseFloat(dtl_c.total_discount).toFixed(2) ):"" }} </vs-td>
                        <vs-td style="text-align: right;">{{formatCurrency( parseFloat(dtl_c.Rounding).toFixed(2) )}}</vs-td>
                        <vs-td style="text-align: right;">{{formatCurrency( parseFloat(dtl_c.Tax).toFixed(2) )}}</vs-td>
                        <vs-td v-if="parseFloat(dtl_c.price) > 0" style="text-align: right;">{{ formatCurrency( parseFloat(dtl_c.total).toFixed(2) )}}</vs-td>
                      </vs-tr>

                      <tr :key="'expand-head-'+index+'-'+i+''+i_c" v-if="dtl_c.is_expand && dtl.detail_combo.length!=0">
                        <td colspan="5" style="width:50%;">
                        <!-- expand-head -->
                          <tr>
                            <!-- <th>Width<br>
                              @{{ dtl_c.width }}
                            </th>
                            <th>
                              Height <br>
                              @{{ dtl_c.height }}
                            </th>
                            <th>Length<br>
                              @{{ dtl_c.length }}
                            </th> -->
                            <th>Weight<br>
                              @{{ dtl_c.weight }}
                            </th>
                            <th>Volume<br>
                              @{{ dtl_c.volume }}
                            </th>
                            <th>Net Weight<br>
                              @{{ dtl_c.net_weight }}
                            </th>
                            <th>Price Rule Code</th>
                            <th>Price Rule Valid From</th>
                            <th>Price Rule Valid To</th>
                            <th>Division Code</th>
                            <th>Division Description</th>
                          </tr>
                          <!-- expand-body -->
                          <tr>
                            <!-- <td>{{ dtl_c.total_width }}</td>
                            <td>{{ dtl_c.total_height }}</td>
                            <td>{{ dtl_c.total_length }}</td> -->
                            <td>{{ dtl_c.total_weight }}</td>
                            <td>{{ dtl_c.total_volume }}</td>
                            <td>{{ dtl_c.total_net_weight }}</td>
                            <td>{{ dtl_c.price_rule_code }}</td>
                            <td>{{ dtl_c.price_rule_valid_from }}</td>
                            <td>{{ dtl_c.price_rule_valid_to }}</td>
                            <td>{{ dtl_c.division_code }}</td>
                            <td>{{ dtl_c.division_description }}</td>
                          </tr>
                        </td>
                      </tr>
                    </template>
                  </template>
                  <tr v-if="dt.all_total != null">
                    <td colspan="5" style="vertical-align: middle; text-align:right;"> <b>Total</b> </td>
                    <td style="vertical-align: middle; text-align:right;"> <b>{{ formatCurrency(dt.all_total.total_netto.toFixed(2)) }}</b> </td>
                    <!-- Hide discount -->
                    <td style="vertical-align: middle; text-align:right;"> <b>{{ formatCurrency(dt.all_total.total_discount.toFixed(2)) }}</b> </td>
                    <td style="vertical-align: middle; text-align:right;"> <b>{{ formatCurrency(dt.all_total.total_rounding.toFixed(2)) }}</b> </td>
                    <td style="vertical-align: middle; text-align:right;"> <b>{{ formatCurrency(dt.all_total.total_tax.toFixed(2)) }}</b> </td>
                    <td style="vertical-align: middle; text-align:right;"> <b>{{ formatCurrency(dt.all_total.total_billing.toFixed(2)) }}</b> </td>
                  </tr>
                  <!-- row free good -->
                  <template v-if="dataFG?dataFG.length>0:false">
                    <tr>
                      <td colspan="100%" class="p-0"> <vs-divider><b>Free Good</b></vs-divider></td>
                    </tr>

                    <tr>
                      <th style="vertical-align: middle; width:30%; text-align: center">SKU Code</th>
                      <!-- v-if="isExistSkuCombo" -->
                      <!-- style="vertical-align: middle; text-align: center;" -->
                      <th style="vertical-align: middle; text-align:center;">Qty</th>
                      <th style="vertical-align: middle; text-align:center; width:15%;">HU</th>
                      <th style="vertical-align: middle; text-align:center;">Cogs</th>
                      <th style="vertical-align: middle; text-align: center">Promotion Code</th>
                      <th style="vertical-align: middle; text-align: center">Promotion Type</th>
                      <th style="vertical-align: middle; text-align:center;">Price</th>
                      <th style="vertical-align: middle; text-align:center;">Subtotal</th>
                      <th style="vertical-align: middle; text-align:center;">Discount</th>
                      <th style="vertical-align: middle; text-align:center;"></th>
                    </tr>
                    <template v-for="(dt, index) in dataFG">
                      <!-- <vs-tr :key="index" v-for="(dt, index) in 3"> -->
                      <!-- for start sku not combo -->
                      <tr :key="index+'-fg'" v-if="!isExistSkuCombo">
                        <td style="align-item-center; vertical-align: middle; width: 300px; max-width: 400px;">
                              <!-- @onSelected="onselected2" -->
                          <strong>{{dataFG[index].fg_component.value?dataFG[index].fg_component.value.text:""}}</strong>
                          <span v-if="(dataFG[index].fg_component.value?dataFG[index].fg_component.value.item_type:undefined)!= undefined" class="text-success">{{dtl.item_type_name }}</span>
                        </td>
                        <td style="vertical-align: middle;">{{ dataFG[index].fg_component.value?dataFG[index].fg_component.value.qty:0 }}</td>
                        <td style="vertical-align: middle;" colspan="1">{{ dataFG[index].fg_component.value?dataFG[index].fg_component.value.item_unit:"" }}</td>
                        <td style="vertical-align: middle;">{{ dataFG[index].fg_component.value?dataFG[index].fg_component.value.cogs:0 }}</td>
                        <td style="vertical-align: middle;" >{{ dataFG[index].fg_component.promotion_code }}</td>
                        <td style="vertical-align: middle;"> {{ dataFG[index].fg_component.promotion_type }}</td>
                        <td style="vertical-align: middle;"> {{ 
                          formatCurrency(parseFloat(dataFG[index].fg_component.value?dataFG[index].fg_component.value.price:0)/
                          parseFloat(dataFG[index].fg_component.value?dataFG[index].fg_component.value.qty:0)) + 
                          (dataFG[index].fg_component.value?(dataFG[index].fg_component.value.capped?" (capped)":""):"")}}
                          </td>
                        <td style="vertical-align: middle;">{{ formatCurrency(dataFG[index].fg_component.value?dataFG[index].fg_component.value.price:0) }}</td>
                        <td style="vertical-align: middle;">{{ formatCurrency(dataFG[index].fg_component.value?dataFG[index].fg_component.value.price:0) }}</td>
                        <td style="vertical-align: middle;"></td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <!-- End -->
          <!-- Additional layout -->
          <div class="vx-row">
            <div class="vx-col w-1/2">
            </div>
            <div class="vx-col w-1/2">
              <table class="table" style="width:100%">
                <thead>
                  <tr>
                    <td style="text-align: right;"><b>Total Net Weight</b></td>
                    <td style="text-align: right;">{{ formatCurrency(dt.all_total.total_net_value.toFixed(2)) }}</td>
                  </tr>
                  <tr>
                    <td style="text-align: right;"><b>Total Weight</b></td>
                    <td style="text-align: right;">{{ formatCurrency(dt.all_total.total_weight.toFixed(2)) }}</td>

                  </tr>
                  <tr>
                    <td style="text-align: right;"><b>Total Volume</b></td>
                    <!-- <td style="text-align: right;">{{ formatCurrency(this.CalcRespData.total_volume) }}</td> -->
                    <!-- <td style="text-align: right;">{{ "this.CalcRespData.total_volume" }}</td> -->
                    <td style="text-align: right;">{{ formatCurrency(dt.all_total.total_volume.toFixed(2)) }}</td>

                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
    <vs-popup fullscreen title="Discount Details" :active.sync="isDetailDisc">
      <div class="vx-row m-2 mt-6">
        <div class="vx-col w-full" v-if="isDetailDisc">
          <DetailDiscount :DetailDataDiscount="detailDataDiscount" :PricingCode="pricingCode" :Pricing="formatCurrency(pricing)"></DetailDiscount>
        </div>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import moment from "moment";
import FormInput from "./form_input.vue"
import Datepicker from "vuejs-datepicker";
import DetailDiscount from "./detail_discount.vue"
import AddressComponent from "@/components/master/Address";
export default {
  components :{
    Datepicker,
    FormInput,
    AddressComponent,
    DetailDiscount,
  },
  props: ["coReqID"],
  data() {
    let id = parseInt(this.$route.params.id);
    // const edit = true;
    if (this.coReqID) {
      id = this.coReqID
    }
    // 1=quantity, 2=value, 3=weight, 4=volume
    // 1=percentage, 2=amount, 5=lowest, 6=sku, 9=choice
    return {
      baseString:["", "quantity", "value", "weight", "volume"],
      discountString:["", "percentage", "amount", "lowest", "sku", "choice"],
      showOTCForm: false,
      rendered: true,
      tabIndex: 0,
      coId: id,
      detailDataDiscount:[],
      pricingCode:"",
      pricing:0,
      isDetailDisc:false,
      baseUrl: "/api/sfa/v1/customer-order/find-by-corequest-id2/",
      detailShow: "core vx-col md:w-1/2 w-full mb-base ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      dataFG:[],
      dataFgAll:[],
      detail: false,
      isErrorBillTo:false,
      msgErrorBillto:"",
      isErrorShippTop:false,
      msgErrorShippTo:"",
      dataCustomerOrder:[],
      selectedCustDeposit:[],
      optionCustDeposit:[],
      title:"View Canvas Order",
      id: id,

      isOneTime: false,
      
      oneTimeCust: {
        id:null,
        customer:null,
        name:null,
        address_manual: null,
        address: {
          address: "",
          postalCode: "",
          countryName: "",
          provinceName: "",
          cityName: "",
          districtName: "",
          subdistrictName: "",
        },
        contact_person:null,
        nik:null,
        phone:null,
        payment_method_id:null,
        tax_id:null,
      },
      optionSoType: [],
    };
  },
  methods: {
    expandNonCombo(iCO, iLine){
      let is_expand = this.dataCustomerOrder[iCO].customer_order_line[iLine].is_expand;
      this.dataCustomerOrder[iCO].customer_order_line[iLine].is_expand = !is_expand;
    },
    expandCombo(iCO, iLine, iCombo, data){
      let is_expand = this.dataCustomerOrder[iCO].customer_order_line[iLine].detail_combo[iCombo].is_expand;
      this.dataCustomerOrder[iCO].customer_order_line[iLine].detail_combo[iCombo].is_expand = !is_expand;
    },
    getRowspanCombo(data_combo){
      console.log(data_combo)
      let rowspan = data_combo.length + 1
      data_combo.forEach(el => {
        console.log(el)
        if(el.is_expand) {
          rowspan++;
        }
      });
      return rowspan;
    },
    showOTForm(){
      this.showOTCForm = true;
      // console.log("tampil", this.showOTCForm);
    },
    handleCloseOt() {
      this.showOTCForm = false;
    },
    handleClose() {
      // back to list
      if (this.coReqID) {
        this.$emit("handleClose");
      }else{
        this.$router.push({ name: "manage-canvas-sales" });
      }
    },
    formatCurrency(value) {
      if (value<=0) {
          return "0"
      }
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    getData_() {
      return new Promise((resolve, reject) => {
        this.$http.get(this.baseUrl + this.coId).then( async(resp) => {
          // console.log(resp);
          if (resp.code == 200) {
            this.dataCustomerOrder = resp.data.records[0];
            console.log("resp 882", resp)
            resolve("resolve lho");
          } else {
            // console.log(resp);
            reject("reject lho");
          }
        }); 
      });
    },
    getDataInit_() {
      return new Promise((resolve, reject) => {
        this.$http.get(this.baseUrl + this.coId).then( async(resp) => {
          console.log(resp);
          if (resp.code == 200) {
            this.dataCustomerOrder = resp.data.records;
            console.log("this.dataCustomerOrder",this.dataCustomerOrder)
            
            // tata ulang data line
            // console.log("dataCustomerOrder.length")
            for (let i = 0; i < this.dataCustomerOrder.length; i++) {
              let all_total = {
                total_netto: 0,
                total_rounding: 0,
                total_tax: 0,
                total_billing: 0,
                total_discount: 0,
                total_net_value: 0,
                total_weight: 0,
                total_volume: 0,
              }
              this.dataCustomerOrder[i].coType = this.getSoType(this.dataCustomerOrder[i].category);
              console.log("this.dataCustomerOrder[i].coType",this.dataCustomerOrder[i].coType)
              this.dataCustomerOrder[i].all_total = {};
              this.dataCustomerOrder[i].is_combo = false
              let coLineSplit = this.dataCustomerOrder[i].customer_order_line;
              let coLineOnly = this.dataCustomerOrder[i].customer_order_line;
              all_total.total_net_value = 0;
              all_total.total_weight    = 0;
              all_total.total_volume    = 0;
              // console.log("coLineSplit.length")
              this.dataCustomerOrder[i].customer_order_line = []; 
              if (coLineSplit) {
                for (let j = 0; j < coLineSplit.length; j++) {
                  let line_data = {};
                  let detailHu = coLineSplit[j].customer_order_request_line_qty_splitters;
                  let itemUnit = coLineSplit[j].item_unit;
                  console.log("detailHu.length",coLineSplit[j])
                  if (detailHu&&!coLineSplit[j].free_item) {
                    for (let k = 0; k < detailHu.length; k++) {
                      // console.log("detailHu.length finish")
                      let detail_combo = [{
                            item_name : "",
                            sku_code : "",
                            quantity : 0,
                            division_code : "",
                            unit_name : "",
                            price : 0,
                            discount : 0,
                            Rounding : 0,
                          }],is_combo = false;
                      if (detailHu[k]) {
                        detail_combo = []
                        console.log("detailHu[k]",detailHu[k]);
                        if (detailHu[k].detail_combo) {
                          detailHu[k].detail_combo.forEach((el_combo)=>{
                            // console.log(el_combo)
                            is_combo = true
                            this.dataCustomerOrder[i].is_combo = true
                            detail_combo.push({
                              item_name : el_combo.ItemName,
                              sku_code : el_combo.SkuCode,
                              quantity : el_combo.Quantity,
                              line:coLineSplit[j].line,
                              division_code : el_combo.division_code,
                              unit_name : el_combo.UnitName,
                              price : el_combo.Price > 0 && el_combo.Quantity >0? (el_combo.Price / detailHu[k].quantity):0,
                              discount : el_combo.Discount,
                              total_discount : el_combo.TotalDiscount,
                              Rounding : el_combo.Rounding,
                              Tax :el_combo.Tax,
                              subtotal :el_combo.Price,
                              total :el_combo.Total,
                              item_type:el_combo.ItemType,
                              item_type_name:el_combo.ItemTypeName,
                              is_expand: false,
                              width:el_combo.width,
                              total_width:el_combo.total_width,
                              weight:el_combo.weight,
                              total_weight:el_combo.total_weight,
                              height:el_combo.height,
                              total_height:el_combo.total_height,
                              length:el_combo.length,
                              total_length:el_combo.total_length,
                              volume:el_combo.volume,
                              total_volume:el_combo.total_volume,
                              net_weight:el_combo.net_weight,
                              total_net_weight:el_combo.total_net_weight,
                              price_rule_code:el_combo.price_rule_code,
                              price_rule_valid_from:moment(el_combo.price_rule_valid_from).format("YYYY-MM-DD"),
                              price_rule_valid_to:moment(el_combo.price_rule_valid_to).format("YYYY-MM-DD"),
                              division_description:el_combo.division_description,
                            })
                          })
                        }
                      }
                      line_data = {
                        sku_code : itemUnit.item.sku_code,
                        sku_name : itemUnit.item.name,
                        quantity : detailHu[k].quantity,
                        unit : detailHu[k].unit_name != "" ? detailHu[k].unit_name : coLineSplit[j].item_unit.unit.Name,
                        price : detailHu[k].quantity != 0 ? (detailHu[k].price / detailHu[k].quantity) : 0,
                        subtotal : detailHu[k].price,
                        discount : detailHu[k].total_discount,
                        Tax : detailHu[k].Tax,
                        total : detailHu[k].total,
                        Rounding : detailHu[k].Rounding,
                        cogs : detailHu[k].cogs,
                        line :coLineSplit[j].line,
                        is_combo : is_combo,
                        free_item:false,
                        item_type: itemUnit.item.item_type.type,
                        item_type_name: itemUnit.item.item_type.name,
                        detail_combo:detail_combo,
                        is_expand: false,
                        width:detailHu[k].width,
                        total_width:detailHu[k].total_width,
                        weight:detailHu[k].weight,
                        total_weight:detailHu[k].total_weight,
                        height:detailHu[k].height,
                        total_height:detailHu[k].total_height,
                        length:detailHu[k].length,
                        total_length:detailHu[k].total_length,
                        volume:detailHu[k].volume,
                        total_volume:detailHu[k].total_volume,
                        net_weight:detailHu[k].net_weight,
                        total_net_weight:detailHu[k].total_net_weight,
                        price_rule_code:detailHu[k].price_rule_code,
                        price_rule_valid_from:moment(detailHu[k].price_rule_valid_from).format("YYYY-MM-DD"),
                        price_rule_valid_to:moment(detailHu[k].price_rule_valid_to).format("YYYY-MM-DD"),
                        division_description:detailHu[k].division_description,
                        division_code:detailHu[k].division_code,
                        promotion:detailHu[k].promotion?detailHu[k].promotion:[],
                      }
                      all_total.total_netto += detailHu[k].price;
                      all_total.total_rounding += detailHu[k].Rounding;
                      all_total.total_tax += detailHu[k].Tax;
                      all_total.total_billing += detailHu[k].total;
                      all_total.total_discount += detailHu[k].total_discount;
  
                      // additional info, net val, weight, and volume
                      all_total.total_net_value += detailHu[k].total_net_weight;
                      all_total.total_weight    += detailHu[k].total_weight;
                      all_total.total_volume    += detailHu[k].total_volume;
  
                      this.dataCustomerOrder[i].customer_order_line.push(line_data);
                      this.dataCustomerOrder[i].all_total = all_total;
                    }
                  }else{
                    let promotion =[]
                    if (coLineOnly[j].promotion) {
                      promotion = coLineOnly[j].promotion
                    }else{
                      promotion = []
                    }
                    line_data = {
                      sku_code : itemUnit.item.sku_code,
                      sku_name : itemUnit.item.name,
                      quantity : coLineOnly[j].quantity,
                      line : coLineOnly[j].line,
                      unit : itemUnit.unit.Name,
                      price : coLineOnly[j].price,
                      subtotal : 0,
                      discount : coLineOnly[j].discount,
                      Tax : 0,
                      total : 0,
                      Rounding : 0,
                      free_item:true,
                      item_type:"",
                      item_type_name:"",
                      is_expand: false,
                      width:0,
                      total_width:0,
                      weight:0,
                      total_weight:0,
                      height:0,
                      total_height:0,
                      length:0,
                      total_length:0,
                      volume:0,
                      total_volume:0,
                      net_weight:0,
                      total_net_weight:0,
                      price_rule_code:0,
                      price_rule_valid_from:"-",
                      price_rule_valid_to:"-",
                      division_description:"-",
                      division_code:"-",
                      fg_component:{
                        disabled: true,
  
                        validate: "required",
                        name: "fg_sku",
                        placeholder: "Sku Code",
                        head:"Sku Code",
                        type: "multiselect",
                        track_by:"sku_code",
                        isLoading:false,
                        multiple: false,
                        allowempty: false,
                        promotion_code:promotion.length?promotion[0].promotion_code:"",
                        promotion_type:promotion.length?promotion[0].promotion_type:"",
                        promotion:promotion,
                        value: {
                          sku_code:itemUnit.item.sku_code,
                          item_id:itemUnit.item_id,
                          item_name:itemUnit.item.name,
                          item_unit:itemUnit.unit.Name,
                          item_unit_id:itemUnit.id,
                          text:"["+itemUnit.item.sku_code+"] "+itemUnit.item.name,
                          qty:coLineOnly[j].quantity,
                          price:coLineOnly[j].price?coLineOnly[j].price/(coLineOnly[j].quantity>0?coLineOnly[j].quantity:0):0,
                          subtotal:coLineOnly[j].price?coLineOnly[j].price:0,
                          discount:coLineOnly[j].discount,
                          cap:promotion.length?promotion[0].cap:0,
                          capped:promotion.length?promotion[0].capped:false,
                          cogs:promotion.length?promotion[0].cogs:false,
                        },
                        optionValue:[],
                      }
                    }
                    console.log("free_item",line_data)
                    this.dataFgAll.push(line_data);
                  }
                }
              }
            }
            console.log("this.dataCustomerOrder",this.dataCustomerOrder)
            resolve(resp);
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "danger",
              title: "Error Get Data",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            reject(resp);
          }
          this.filterDataFg(this.dataCustomerOrder[0].customer_order_line[0].line)
        }); 
      });
    },
    getSOTypes(){
      // this.$vs.loading();
      return new Promise((resolve, reject) => {
      // this.$http.get("api/v1/master/sales-order-type", {
      this.$http.get("api/oms/v1/sfa-sales-order/sales-order-type", {
          params: {
            order: 'name',
            sort: 'asc',
          }
        }).then(resp => {
            // console.log(resp)
            if (resp.code == 200) {
              this.optionSoType = resp.data.records;
              resolve(true);
            } else {
                this.$vs.notify({
                    title: "Error",
                    text: "Failed to get Sales Order Type option",
                    color: "danger",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle"
                });
                reject(false);
            }
          // this.$vs.loading.close();
        });
      });
    },
    formatDate(value) {
      // console.log(value)
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      } else {
        return "-";
      }
    },
    getSoType(code){
      console.log("this.optionSoType", this.optionSoType)
      let soType = this.optionSoType.filter((v) => {
        console.log(v.Code,"==",code,v.Code == code)
        if(v.Code == code){
          return v
        }
      });
      soType = soType[0];
      return soType;
    },
    async getCustDeposit_(cust_id) {
      let resp = await this.$http.get(
        `api/oms/v1/sfa-sales-order/cash-bank/customer-deposit/${cust_id}`
      );
      console.log("resp", resp);      
      console.log(resp);
      if (resp.status == "success") {
        console.log("data cust order inside getCustDeposit_", this.dataCustomerOrder)
        if(resp.data.cashBank.length > 0){
          this.optionCustDeposit = resp.data.cashBank;
          console.log("677 this.optionCustDeposit", this.optionCustDeposit)

          this.optionCustDeposit.forEach(ocd => {
            this.dataCustomerOrder[0].co_deposits.forEach(cod => {
              if(ocd.ID == cod.DepositID) {
                this.selectedCustDeposit.push(ocd);
              }
            });
          });
          console.log("688 this.selectedCustDeposit", this.selectedCustDeposit)
        }
      }
    },
    redirectTab(i){
      this.filterDataFg(this.dataCustomerOrder[i].customer_order_line[0].line)
    },
    filterDataFg(line){
      this.dataFG = this.dataFgAll.filter(el=>
        el.line == line
      )
    },
    detailDiscShow(i,i2){
      this.isDetailDisc = true
      if (this.dataCustomerOrder[i].customer_order_line&&this.dataCustomerOrder[i].customer_order_line.length>0) {
        this.pricingCode = this.dataCustomerOrder[i].customer_order_line[i2].price_rule_code
        this.pricing = this.dataCustomerOrder[i].customer_order_line[i2].price.toFixed(2)
        let promotion = this.dataCustomerOrder[i].customer_order_line[i2].promotion
        this.detailDataDiscount = [];
        promotion.forEach((el)=>{
          this.detailDataDiscount.push({
            "add":el.add,
            "add_rate":el.add_rate,
            "amount":el.amount,
            "base":el.base,
            "base_amount":el.base_amount,
            "base_string":this.baseString[el.base?el.base:0],
            "cap":el.cap,
            "capped":el.capped,
            "discount_string":this.discountString[el.discount_type?el.discount_type:0],
            "discount_type":el.discount_type,
            "from":el.from,
            "main":el.main,
            "main_rate":el.main_rate,
            "order_line":el.order_line,
            "order_line_after_discount":el.order_line_after_discount,
            "promotion_code":el.promotion_code,
            "promotion_id":el.promotion_id,
            "promotion_item_req_id":el.promotion_item_req_id,
            "promotion_sequence":el.promotion_sequence,
            "promotion_step_id":el.promotion_step_id,
            "promotion_type":el.promotion_type,
            "qty":el.qty,
            "to":el.to,
            // "valid":promotion.valid
          })
        })
      }else{
        this.detailDataDiscount = []
      }
    },
    getCustDeposit(cust_id) {
      this.$vs.loading();
      this.$http.get("api/oms/v1/sfa-sales-order/cash-bank/customer-deposit/" + cust_id).then((resp) => {
        console.log(resp);
        if (resp.status == "success") {
          if(resp.data.cashBank.length > 0){
            this.optionCustDeposit = resp.data.cashBank;
            console.log("657 this.optionCustDeposit", this.optionCustDeposit)
          } else {
            this.$vs.notify({
              title: "Warning",
              text: "No deposit found ! Please add or create one first !",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-circle"
            });
          }
          this.$vs.loading.close();
        } else {
          this.$vs.loading.close();
        }
      });
    },
    customLableCustDeposit({ Code, DepositValue }){
      return `${Code} - Value : ${this.formatCurrency(DepositValue)}`;
    },
  },
  filters: {
    formatCurrency(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
  mounted() {
    this.$vs.loading();
    Promise.all([
      this.getSOTypes(),
      this.getDataInit_(),
    ]).then((r) => {
      console.log(r);
      if(this.dataCustomerOrder[0].category == "ZDCBD"){
        this.getCustDeposit_( parseInt(this.dataCustomerOrder[0].customer_id));
      }

      this.rendered = false;
      this.$nextTick(()=>{
        this.rendered = true;
      });
      this.$vs.loading.close();
      this.$vs.notify({
          color: "success",
          title: "Get Data",
          text: r[0].message,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check-circle",
        });
    }).catch(function (error) {
      console.log(error);
    });
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>

<style scoped>
.badge.badge-success {
  background-color: #28c76f;
}
.badge {
  font-weight: 400;
  color: #fff;
  background-color: #7367f0;
}
.badge-success {
  color: #fff;
  background-color: #28c76f;
}
.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
.vs-table--thead{
  z-index:-1 !important;
  display: none;
}
.table-expend:hover,.table-expend-combo:hover td.combo-hover{
    background: #e9e9e9;
    cursor: pointer;
}
.table-expend:active,.table-expend-combo td.combo-hover:active{
    background: #e7e5e5;
}
</style>
